//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageFooter from '@/components/PageFooter'
import { getSectionList } from '@/api/section'
// import { chain } from 'lodash'

import { scroll } from 'quasar'
const { getScrollTarget, setScrollPosition } = scroll

export default {
  name: 'Artwork',
  components: { PageFooter },
  data () {
    return {
      sectionList: [],
      refScrollStartList: [],
      navList: [],
      navIndex: 0
    }
  },
  async created() {
    // console.log('created start')
    await this.fetchData();
    window.addEventListener('scroll', this.onScroll)
    // console.log('created end')
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  computed: {
    langNotEn() {
      return localStorage.getItem('keio.lang') !== 'en';
    }
  },
  methods: {
      async fetchData() {
          this.sectionList = await getSectionList();
          // console.log('sectionList')
          // console.log(this.sectionList)
          this.sectionList = this.sectionList.map(oneSection => {
            // const sorted = chain(oneSection.artworks).sortBy(v => -parseInt(v.id)).value()
            oneSection.artworksToShow = oneSection.artworks.filter(v => v.id === oneSection.showArtworkId)
            // if (oneSection.artworksToShow.length === 0) {
            //   oneSection.artworksToShow = oneSection.artworks
            // }
            return oneSection
          })
          this.navList = this.sectionList.map(v => v.name)
          this.navList.unshift(localStorage.getItem('keio.lang') !== 'en'?'概要':'概要')
          // console.log(this.navList)

          this.$nextTick(() => {
            this.handleResize()
          })
      },
      scrollTo(refName, index) {
        // console.log(index)
        // console.log(refName)
        var element = (index !== -1 ? this.$refs[refName][0] : this.$refs['top'])

        const target = getScrollTarget(element)
        const offset = element.offsetTop
        const duration = index !== -1 ? 120 + 45 * (index + 1) : 200
        setScrollPosition(target, offset, duration)
        this.onScroll()
      },
      onScroll () {
        if (this.refScrollStartList.length === 0) {
          this.navIndex = 0
          return
        }

        if (window.pageYOffset < this.refScrollStartList[0]) {
          this.navIndex = 0
        } else if (window.pageYOffset >= this.refScrollStartList[this.refScrollStartList.length - 1]) {
          this.navIndex = this.refScrollStartList.length
        } else {
          this.refScrollStartList.map((v, i) => {
            if (window.pageYOffset >= this.refScrollStartList[i] && window.pageYOffset < this.refScrollStartList[i + 1]) {
              this.navIndex = i + 1
            }
          })
        }
      },
      handleResize() {
        // console.log('handleResize')
        this.sectionList.map((v, i) => {
          const refName = `scroll_ref_${i}`
          this.refScrollStartList[i] = this.$refs[refName][0].offsetTop
        })
      }
  }
}
